// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { TrialSignupApp } from './app.module';
bootstrapAppModule(TrialSignupApp);
